import moment from 'moment';

function timeago(publishedAt) {
  const time = Math.floor(Date.now() / 1000) - publishedAt;
  if (time < 1) {
    return 'vừa xong';
  }
  const a = [
    { number: 31536000, name: 'năm' },
    { number: 2592000, name: 'tháng' },
    { number: 86400, name: 'ngày' },
    { number: 3600, name: 'giờ' },
    { number: 60, name: 'phút' },
    { number: 1, name: 'giây' },
  ];
  for (let i = 0; i < a.length; i++) {
    const d = time / a[i].number;
    if (d >= 1) {
      const r = Math.round(d);
      return `${r} ${a[i].name}`;
    }
  }
  return publishedAt;
}
/**
 * Format date from Y-m-d H:i:s to H:i d/m/Y
 * @param string date
 */
function formatDate(date) {
  return moment(date).format('DD/MM/YYYY HH:mm');
}
export {
  timeago,
  formatDate,
}
